<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <!-- 提现地址信息 -->
      <div v-if="addressInfo" class="withdrawAddress">
        <div class="address-header">
          <span>{{$t("withdraw.withdraw_address_info")}}</span>
        </div>
        <div class="address-card">
          <div class="address-row">
            <span class="label">{{$t("withdraw.coin_type")}}:</span>
            <span class="value">{{addressInfo.bankinfo}}</span>
          </div>
          <div class="address-row">
            <span class="label">{{$t("withdraw.network_type")}}:</span>
            <span class="value">{{addressInfo.bankfenhang}}</span>
          </div>
          <div class="address-row">
            <span class="label">{{$t("withdraw.wallet_address")}}:</span>
            <span class="value address-text">{{addressInfo.bankid}}</span>
          </div>
        </div>
      </div>

      <div class="withdrawMoney">
        <span>{{$t("withdraw.with_money")}} ({{$t("reservation.unit")}})</span>
        <div class="money">
          <div class="moneyNumber">
            <van-field v-model="withdraw_money" type="number" />
          </div>
          <span class="all" @click="allMoeny()">{{$t("index.all")}}</span>
        </div>

        <!-- 提款密码输入框 -->
        <div class="password-field">
          <span>{{$t("setting.finance_pwd")}}</span>
          <div class="password-input">
            <van-field
              v-model="pay_password"
              type="password"
              :placeholder="$t('auth.pay_pwd_place')"
              maxlength="6"
            />
          </div>
        </div>

        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}{{$t("reservation.unit")}}</p>
                <p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
                <p>3.{{$t("withdraw.with_tip")}}</p></div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o" />
                {{$t("withdraw.limit_desc")}}
              </template>
            </van-popover>
          </div>

          <div class="balance">
            <span>{{$t("my.balance")}}：</span>
            <span class="number">{{ this.userInfo.money }}{{$t("reservation.ge")}}</span>
          </div>
        </div>
      </div>
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()"> {{$t("withdraw.immediately_withdraw")}}</van-button>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money: "",
      pay_password: "",
      userInfo: {},
      withdrawRole: {},
      defaultAddressId: null,
      addressInfo: null
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;

          // 检查是否设置了提现密码
          if(!res.data.paypassword || res.data.paypassword === '' || res.data.paypassword === null){
            // 没有提现密码，跳转到设置提现密码页面
            this.$toast(this.$t("withdraw.please_set_pay_password_first"));
            this.$router.push({path: '/SetPayPassword'});
          } else {
            // 有提现密码，继续检查提现地址
            this.getCryptoAddresses();
          }
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if(res.code === 200){
          this.withdrawRole = res.data;
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    getCryptoAddresses(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if(res.code === 200){
          if(res.data.is_crypto && res.data.crypto_list && res.data.crypto_list.length > 0){
            // 有地址，默认使用第一个
            this.addressInfo = res.data.crypto_list[0];
            this.defaultAddressId = res.data.crypto_list[0].id;
          } else {
            // 没有地址，跳转到绑定页面
            this.$toast(this.$t("withdraw.please_bind_address_first"));
            this.$router.push({path: '/BindCard'});
          }
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      // 验证提现金额
      if(this.withdraw_money <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }

      // 验证提款密码
      if(!this.pay_password || this.pay_password === ''){
        this.$toast(this.$t("auth.pay_pwd_place"));
        return false;
      }

      // 验证密码长度
      if(this.pay_password.length !== 6){
        this.$toast(this.$t("auth.pay_pwd_error"));
        return false;
      }

      // 验证是否有默认地址
      if(!this.defaultAddressId){
        this.$toast(this.$t("withdraw.please_bind_address_first"));
        this.$router.push({path: '/BindCard'});
        return false;
      }

      // 提交提现请求
      this.$http({
        method: 'post',
        data: {
          money: this.withdraw_money,
          paypassword: this.pay_password,
          address_id: this.defaultAddressId
        },
        url: 'user_set_withdraw'
      }).then(res => {
        if(res.code === 200){
          location.reload()
          this.$toast(res.msg);
          this.getUserInfo();
          this.getUserWithdrawRole();
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo(); // 会在内部调用 getCryptoAddresses
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}
.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}

/* 提现地址信息展示 */
.withdrawAddress {
  background-color: #fff;
  margin-bottom: 15px;
  padding: 20px;
  border-radius: 8px;
}

.address-header {
  margin-bottom: 20px;
  font-size: 32px;
  font-weight: 600;
  color: #333;
}

.address-card {
  background-color: #f7f8fa;
  border-radius: 8px;
  padding: 20px;
}

.address-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  font-size: 28px;
}

.address-row:last-child {
  margin-bottom: 0;
}

.address-row .label {
  color: #646566;
  font-weight: 500;
  min-width: 140px;
  flex-shrink: 0;
}

.address-row .value {
  color: #323233;
  flex: 1;
  word-break: break-all;
}

.address-row .address-text {
  font-family: monospace;
  font-size: 24px;
  line-height: 1.6;
}

.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .password-field {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .password-field span {
  padding: 10px 0;
  font-size: 35px;
}
.container .main .withdrawMoney .password-field .password-input {
  display: flex;
  align-items: center;
}
.container .main .withdrawMoney .password-field .password-input .van-cell {
  font-size: 35px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
